import React from 'react'
import CheckBoxRow from 'sprockets_react/job_wizards/components/CheckBoxRow'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.SubCategory = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    this.verifyCantFindSelection()
    this.verifySubcategorySelection()
    onStepProgression()
  },

  verifyCantFindSelection: function() {
    let $noMatchOption  = $('.js-subcategory-no-match .check-box')
    let noMatchSelected = $noMatchOption.hasClass('active')
    if(noMatchSelected === false && Job.Data.category_id === 0) {
      $('#job-modal').bootstrapValidator('enableFieldValidators', 'category', true)
    }
  },

  verifySubcategorySelection: function() {
    let hasSelectedSubcategory = Job.Data.categories.length > 0
    let validator = JobWizard.Validator
    let validationStatus = (hasSelectedSubcategory || this.selectedNoSubcategoryMatchesOption()) ? 'VALID' : 'INVALID'

    validator.updateMessage('category', 'notEmpty', 'Please select one of the options above, or try another search term.')
    validator.updateStatus('category', validationStatus, 'notEmpty')
  },

  selectedNoSubcategoryMatchesOption: function() {
    return $('.js-subcategory-no-match .check-box.active').length > 0
  },

  component: React.createClass({
    componentWillUnmount: function() {
      this.state = {
        isNoMatchCategory: false,
        emptySearch: 1,
        loading: true
      }
    },

    getInitialState: function() {
      const job = Job.Data;

      return {
        categories:   job.categories,
        category:     job.category,
        category_id:  job.category_id,
        categoryList: []
      }
    },

    onRequest: function() {
      this.state.loading =  true
    },

    onRequestCompletion: function() {
      this.state.loading = false
    },

    componentDidMount: function() {
      $('#subcategory-check-box-group').checkBoxGroup({ activeRowClass: 'active' });

      this.industryList(this.state.category, this.updateCategories, this.onRequest, this.onRequestCompletion)
    },

    categoryChanged: function(e) {
      let $selectedItem  = $(e.currentTarget).find('[type="checkbox"]')
      let $noMatchOption = $('.js-subcategory-no-match .check-box')
      let subCategoryId  = Number($selectedItem.attr('id'))
      let action         = this.isChecked(subCategoryId) ? 'remove' : 'add'

      this.unselectOption($noMatchOption)

      Job.Actions.updateSubCategory({
        id:    subCategoryId,
        value: $selectedItem.val()
      }, action)
    },

    clearCategories: function(e) {
      let $noMatchOption  = $('.js-subcategory-no-match .check-box')
      let $categories     = $('#subcategory-check-box-group > .check-box')
      let noMatchSelected = $noMatchOption.hasClass('active')
      
      noMatchSelected ? this.unselectOption($noMatchOption) : this.selectOption($noMatchOption)

      Job.Actions.updateCategory({id: 0, value: ''})
      Job.Actions.updateKeyword(null)
      Job.Actions.resetCategories()

      if(noMatchSelected === false) {
        $('#job-modal').bootstrapValidator('enableFieldValidators', 'category', false)
      }

      this.unselectOption($categories)

      this.setState({
        isNoMatchCategory: noMatchSelected,
        categories: []
      })

      $categories.each( function(index, element) {
        Job.Actions.updateSubCategory({
          id:    Number(element.id),
          value: element.value
        }, 'remove')
      })
    },

    selectOption: function($element) {
      $element.addClass('active')
              .find('.tick')
              .removeClass('hidden')
    },

    unselectOption: function($element) {
      $element.removeClass('active')
              .find('.tick')
              .addClass('hidden')
    },

    industryList: function(query, cb, onRequest, onRequestCompletion) {
      $.ajax($.extend(SS.API.V3.subCategoriesGet({ 'filter[q]': query, 'page[size]': 5 }), {
        beforeSend: onRequest
      }))
        .always(onRequestCompletion)
        .done(function(response) {
          (this.removeLoader != null && this.state.loading == true) ? this.removeLoader() : ''
          cb(response.data.map(item => ({ id: parseInt(item.id, 10), name: item.attributes.name })))
        })
        .fail(function() {
          document.location = "/500"
        })
    },

    updateCategories: function(categories) {
      let results = categories.map(item => ({ id: item.id, value: item.name }))

      this.setState({
        categoryList: results
      });
    },

    isChecked: function(category_id) {
      let selectedCategories = Job.Data.categories.map(function(el) {return el.id})
      return selectedCategories.indexOf(category_id) >= 0
    },

    render: function() {
      let selectedClass = "col-xs-2 col-sm-2 tick"
      let unselectedClass = "col-xs-2 col-sm-2 tick hidden"

      return (
        <div className="form-group">
          <h3 className="mb15 mt10">What best describes what you need?</h3>
          <div className="check-box-container minor-bold" id="subcategory-check-box-group">
            {this.state.categoryList.map((category) => {
              if (category.id != this.state.category_id) {
                return (
                  <CheckBoxRow name="subcategory" key={category.id}
                    text={category.value} id={category.id}
                    value={category.value} isChecked={this.isChecked(category.id)}
                    onClickHandler={this.categoryChanged} />
                )
              }}, this)}
          </div>
          <div className="no-subcategory-match">
            <h3 className="mb15 mt10">Can't find what you need?</h3>
            <div className="industry-search">
              <i className="ficon-search"/>
              <JobWizard.Category
                emptySearch={this.state.emptySearch}
                isNoMatchCategory={this.state.isNoMatchCategory}
                placeholder="Click here to try another search term"
              />
            </div>
          </div>
          <div className="check-box-container minor-bold js-subcategory-no-match mt10">
            <div className="check-box" onClick={this.clearCategories}>
              <div className="row">
                <div className="col-xs-10 col-sm-10 major-bold">
                  I can't find a match for what I need.
                </div>
                <div className="col-xs-2 col-sm-2 tick hidden">
                  <i className="ficon-tick pull-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
